"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxeResultsMessage = void 0;
var chalk_1 = __importDefault(require("chalk"));
var getAxeResultsMessage = function (results) {
    return results
        .map(function (result) {
        return chalk_1.default.bgRed("Accessibility Issue:") +
            " ".concat(chalk_1.default.red(result.description), "\n") +
            "Impact: ".concat(chalk_1.default.yellowBright(result.impact), "\n") +
            "Rule ID: ".concat(chalk_1.default.yellowBright(result.id), "\n") +
            "Help: ".concat(chalk_1.default.green(result.help), "\n") +
            "Url: ".concat(chalk_1.default.green(result.helpUrl), "\n") +
            "Tags: ".concat(chalk_1.default.blue(result.tags.join(', ')), " \n") +
            'The issues are present in the following elements: \n\n' +
            result.nodes
                .map(function (nodeResult) {
                return "".concat(chalk_1.default.bgGray(nodeResult.html), "\n") +
                    "".concat(chalk_1.default.yellow(nodeResult.failureSummary), "\n");
            })
                .join('\n');
    })
        .join('\n');
};
exports.getAxeResultsMessage = getAxeResultsMessage;
